import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { DesignAngularKitModule } from 'design-angular-kit';

export interface DashboardCardLink {
  label: string;
  route: string;
  queryParams?: { [key: string]: any };
}

@Component({
  selector: 'app-dashboard-card',
  standalone: true,
  imports: [CommonModule, RouterModule, DesignAngularKitModule],
  templateUrl: './dashboard-card.component.html',
  styleUrl: './dashboard-card.component.scss',
})
export class DashboardCardComponent {
  @Input() total: number = 0;
  @Input() title: string = '';
  @Input() links: DashboardCardLink[] = [];
  @Input() textColor: string = 'white';
  @Input() bgColor: string = 'primary';

  constructor(private router: Router) {}

  navigateTo(link: { route: any[] | string; queryParams?: any }) {
    this.router.navigate([link.route], { queryParams: link.queryParams });
  }
}
